import { useMutation } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';
import { AxiosError } from 'axios';
import { AttendanceCommand } from '../../../types/Event';

export const updateEventAttendance = async (uuid: string, command: AttendanceCommand) => {
  return await CustomAxios.put(`events/${uuid}/update_attendance`, { command });
};

interface UseUpdateEventAttendanceProps {
  uuid: string;
  onSuccessCallback?: () => void;
}

export function useUpdateEventAttendance({ uuid, onSuccessCallback }: UseUpdateEventAttendanceProps) {
  return useMutation({
    mutationFn: (command: AttendanceCommand) => updateEventAttendance(uuid, command),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.allEvents, uuid] });
      queryClient.invalidateQueries({ queryKey: [queryKeys.eventAttendance] });
      onSuccessCallback?.();
    },
    onError: (err: AxiosError) => {
      console.log(err.response);
    },
  });
}
